import React, { useContext, useState, useEffect } from 'react';
import { PersonContext } from '../providers/Person.jsx';
import requests from '../utils/requests.js';
import { s } from '../Style.jsx';

const Home = ({ waitForAuth }) => {

    const { authorizing, auth } = useContext(PersonContext);

    const [vendors, setVendors] = useState([]);
    const [gettingVendors, setGettingVendors] = useState(true);
    useEffect(() => {
        requests.getVendors(auth).then(vendors => {
            setVendors(vendors);
            setGettingVendors(false);
        });
    }, [auth]);

    if (waitForAuth && authorizing) return <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <i className="fas fa-spinner fa-spin"></i>
    </div>;

    const businessHours = (hours) => {

        const timeToMinutes = (time) => {
            const [h, m] = time.split(':').map(Number);
            return h * 60 + m;
        };

        const militaryTo12 = (time) => {
            const [h, m] = time.split(':').map(Number);
            const suffix = h >= 12 ? 'PM' : 'AM';
            const hour = h % 12 || 12;
            return `${hour}:${m.toString().padStart(2, '0')} ${suffix}`;
        };

        const day = new Date().toLocaleString("en-US", { weekday: "long", timeZone: "America/New_York" });
        const minutes = timeToMinutes(new Date().toLocaleString("en-US", { hour: "2-digit", minute: "2-digit", hour12: false, timeZone: "America/New_York" }).split(" ")[0]);

        let open, close;
        if (hours && Array.isArray(hours)) {
            open = hours.find(h => h.day === day && h.open);
            close = hours.find(h => h.day === day && h.close);
        }

        //contaraints && defaults
        if (parseInt(open.open.split(":")[0]) < 10 || !open || !close) open.open = (day === "Sunday") ? "12:00" : "10:00";
        if (parseInt(close.close.split(":")[0]) < 10 || !open || !close) close.close = (day === "Sunday") ? "12:00" : "10:00";

        //closed (morning)
        if (timeToMinutes(open.open) > minutes) 
            return <p style={{ color: "red", fontSize: 14, marginTop: 0 }}>Closed - Opens at: {militaryTo12(open.open)}</p>;

        //closed (night)
        if (timeToMinutes(close.close) < minutes) 
            return <p style={{ color: "red", fontSize: 14, marginTop: 0 }}>Closed</p>;

        //closes soon
        if (timeToMinutes(close.close) - minutes < 60)
            return <p style={{ color: "orange", fontSize: 14, marginTop: 0 }}>Open - Closes at: {militaryTo12(close.close)}</p>;

        //open
        return <p style={{ color: "green", fontSize: 14, marginTop: 0 }}>Open - Closes at: {militaryTo12(close.close)}</p>;

    };


    return <div>
        <div style={{ maxWidth: 1200, margin: "auto" }}>
            <div className="wrapontablet" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <div style={{ flex: 2, overflow: "hidden", alignItems: "center", width: "100%" }}>
                    <video style={{ margin: "0", position: "relative", objectFit: "cover", objectPosition: "left", width: "100%", minHeight: "400px", maxHeight: "700px" }} autoPlay={true} muted={true} playsInline={true} src="https://firebasestorage.googleapis.com/v0/b/versatile-express.appspot.com/o/assets%2F00003.mp4?alt=media&token=d4c616d3-0427-483b-982b-2b93c788b669"></video>
                    <div className="flyup" style={{ position: "relative", background: "white", padding: "20px 0", borderRadius: 20, width: "75%", margin: "auto", boxShadow: "0 0 20px 0 #00000033" }}>
                        <h1 style={{ fontWeight: "bold", textAlign: "center" }}>Thunder Bay's <b style={{ display: "block", color: "#cb2121" }}>Local Delivery Service</b></h1>
                        <span style={{ margin: "auto", textAlign: "center", display: "block" }}>Click here to...</span>
                        <a href="/cart?orderAnything"><button style={{ width: "80%", background: "#000", color: "white", padding: "14px 20px", border: "none", borderRadius: 10, cursor: "pointer", fontSize: 14, margin: "8px auto 20px", display: "block", boxShadow: "0 0 10px 0 #00000033" }}>Order Anything from Anywhere</button></a>
                    </div>
                </div>
                <div style={{ flex: 1.2, padding: "20px", marginTop: 50, textAlign: "center", borderLeft: "2px solid #ccc" }}>
                    <h1 style={{ fontWeight: "bold", fontSize: 28 }}>Thunder Bay's <b style={{ color: "#cb2121" }}>Local Delivery Service</b><br />Download the App Today!</h1>
                    <img alt="" className="flyup" style={{ marginTop: 100, width: 300, height: 590 }} src="https://firebasestorage.googleapis.com/v0/b/versatile-express.appspot.com/o/newAssets%2Fphonepreview.png?alt=media&token=384724e6-5d8e-4bef-844b-3b3ceb971e60" />
                </div>
            </div>
        </div>

        <div style={{ background: "#cb2121", padding: "60px 20px", marginTop: "-10px", position: "relative" }}>
            <div style={{ maxWidth: 1200, margin: "auto" }}>
                <div style={{ margin: "auto", position: "relative", alignItems: "center" }}>
                    <div>
                        <h1 style={{ color: "white", fontWeight: "initial" }}>DELIVERING&nbsp;TO THUNDER&nbsp;BAY <b>FOR&nbsp;OVER&nbsp;20&nbsp;YEARS</b></h1>
                        <h2 style={{ color: "white", fontWeight: "bold", marginBottom: 0 }}>Order anything from anywhere</h2>
                        <p style={{ color: "white", marginTop: "5px", }}>From moving furniture, to fast food delivery. The Versatile Express and it’s affiliates work together to bring you what you need. Use our App to place an order for anything you need, and our experienced drivers will take care of it.</p>
                    </div>
                    <div style={{ textAlign: "center", paddingTop: 40, paddingBottom: 40 }}>
                        <a style={{ color: "white", padding: "15px 23px", border: "2px solid", marginRight: "20px", fontWeight: "bold", }} href="https://play.google.com/store/apps/details?id=com.versatileexpress">PLAY STORE</a>
                        <a style={{ color: "#cb2121", padding: "15px 23px", border: "2px solid white", background: "white", fontWeight: "bold", }} href="https://apps.apple.com/ca/app/versatile-express/id1631043225">APP STORE</a>
                    </div>
                    <div style={{ position: "absolute", width: "80px", height: "80px", background: "#f5f5f5", bottom: "-126px", left: "60px", transform: "rotate(45deg)", }}> </div>
                </div>

            </div>
        </div>

        <div style={{ padding: "60px 20px", background: "#f5f5f5" }}>
            <div style={{ maxWidth: 1200, margin: "auto" }}>
                {gettingVendors && <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: 200 }}>
                    <i class="fas fa-spinner fa-spin"></i>
                </div>}

                {!gettingVendors && <div id="listings" style={{ margin: "auto", position: "relative" }}>
                    <h2 style={{ marginTop: 0, textAlign: "center", fontSize: 28 }}>Browse Products</h2>

                    <div style={s.vendorLinks}>
                        <div style={s.vendorIntro}>
                            <h2 style={{ fontSize: 32, color: "#333", marginTop: 0 }}>Delivering what you crave</h2>
                            <p style={{ fontSize: 18, color: "#777" }}>The Versatile Express and its affiliates have got you covered for all your needs, from moving furniture to fast food delivery. With our easy-to-use app, simply place an order for anything you require and our skilled drivers will take care of the rest. Trust us to provide efficient and reliable service every time.</p>
                        </div>
                        {vendors.filter(vendor => vendor.showInApp && vendor.enableMenus).map((vendor, i) => <a style={s.vendorLink} href={`/store?view=${vendor.name}`}>
                            <span style={{ textAlign: "center", fontSize: 14, color: "#777" }}>{businessHours(vendor.businessHours)}</span>
                            <img alt="" style={s.vendorImage} src={(vendor.images && vendor.images[0]) || ""} />
                            <p style={s.vendorName}>{vendor.name}</p>
                        </a>)}
                    </div>

                    <h3 style={{ marginTop: 40, textAlign: "center", fontSize: 28 }}>Our Partners</h3>

                    <div style={s.vendorLinks}>
                        {vendors.filter(vendor => vendor.showInApp && !vendor.enableMenus).map((vendor, i) => <a style={s.vendorLink} href={vendor.url}>
                            <img alt="" style={s.vendorImage} src={(vendor.images && vendor.images[0]) || ""} />
                            <p style={s.vendorName}>{vendor.name}</p>
                        </a>)}
                    </div>

                </div>}

            </div>
        </div>

        <div style={{ background: "#cb2121", padding: "60px 20px", position: "relative", overflow: "hidden" }}>
            <div style={{ margin: "auto", position: "relative", maxWidth: 1200 }}>

                <h2 style={{ color: "white", fontWeight: "bold", }}>Convenience at your fingertips</h2>
                <p style={{ color: "white", }}>At The Versatile Express and its affiliates, we pride ourselves on providing comprehensive solutions for all your needs. From transporting furniture to delivering fast food, we have the expertise and resources to ensure that your requests are fulfilled promptly and efficiently. Our state-of-the-art app allows you to place your orders with ease, and our team of experienced drivers will ensure that they are delivered to you in a timely and professional manner. Trust us to be your go-to provider for all your delivery and transportation needs.</p>
                <p style={{ color: "white", }}>At The Versatile Express, we understand the importance of convenience and efficiency in today's fast-paced world. That's why we are thrilled to offer a wide range of products and services from our reputable affiliates, delivered straight to your doorstep. Whether you're craving a hot meal from your favorite fast food restaurant or you need help moving furniture to your new home, our team of experienced drivers and state-of-the-art app make it easy for you to get exactly what you need, when you need it. Our app allows you to place your order with ease, and our skilled drivers will ensure that it is delivered to you promptly and professionally. From transportation to delivery services, we have the resources and expertise to ensure that your requests are fulfilled in a timely manner. Trust us to provide comprehensive solutions for all your needs and make your life a little bit easier. Whether you're looking for a quick bite to eat or you need help moving furniture, The Versatile Express has got you "cover"ed.</p>
                <p style={{ color: "white", }}>Experience the ultimate convenience with our new mobile app, now available for download on both iOS and Android devices. Developed by a team of local experts who are dedicated to customer satisfaction, our app is designed to make ordering and receiving products and services as seamless as possible. With a user-friendly interface and easy-to-use features, our app allows you to place orders and track deliveries with just a few taps. At The Versatile Express, we are committed to providing the best service possible, which is why we value feedback from our customers. Our team of developers is constantly working to improve the app, making it even more efficient and user-friendly. Don't miss out on the convenience and ease of use that our app offers, download it today and experience the difference for yourself!</p>

            </div>
        </div>

    </div>;
}
export default Home;